import WPStagingCommon from '../../wpstg.js';
import {qs} from '../../modules/wpstg-dom-utils.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup';

let WPStagingBackupCreate;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupCreate.listen();
  });

  window.addEventListener('startedCreatingBackup', function() {
    window.addEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
  });

  WPStagingBackupCreate = {
    listen() {
      $('body')
          .off('click', '#wpstg-new-backup', WPStagingBackupCreate.clickedBackup)
          .on('click', '#wpstg-new-backup', WPStagingBackupCreate.clickedBackup)
          .off('change', '.wpstg--swal2-container .wpstg-advanced-options-site input[type=checkbox]')
          .on('change', '.wpstg--swal2-container .wpstg-advanced-options-site input[type=checkbox]', WPStagingBackupCreate.warnExportMediaWithoutDatabase)
          .off('change', '[name="includedDirectories\[\]"], input#includeDatabaseInBackup, input#includeOtherFilesInWpContent')
          .on('change', '[type="checkbox"][name="includedDirectories\[\]"], input#includeDatabaseInBackup, input#includeOtherFilesInWpContent', WPStagingBackupCreate.disableButtonIfNoSelection)
      ;
    },
    async clickedBackup(e) {
      WPStagingCommon.resetErrors();
      e.preventDefault();
      WPStagingBackup.isCancelled = false;

      if (!WPStagingBackup.modal.create.html || !WPStagingBackup.modal.create.confirmBtnTxt) {
        const $newBackupModal = $('#wpstg--modal--backup--new');
        const html = $newBackupModal.html();
        const btnTxt = $newBackupModal.attr('data-confirmButtonText');
        WPStagingBackup.modal.create.html = html || null;
        WPStagingBackup.modal.create.confirmBtnTxt = btnTxt || null;
        $newBackupModal.remove();
      }

      const {value: formValues} = await WPStagingCommon.getSwalModal(false, {
        confirmButton: 'wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn',
      }).fire({
        title: '',
        html: WPStagingBackup.modal.create.html,
        focusConfirm: false,
        confirmButtonText: WPStagingBackup.modal.create.confirmBtnTxt,
        showCancelButton: true,
        preConfirm: () => {
          const container = WPStagingCommon.getSwalContainer();

          return {
            name: container.querySelector('input[name="backup_name"]').value || null,
            isExportingPlugins: container.querySelector('#includePluginsInBackup:checked') !== null,
            isExportingMuPlugins: container.querySelector('#includeMuPluginsInBackup:checked') !== null,
            isExportingThemes: container.querySelector('#includeThemesInBackup:checked') !== null,
            isExportingUploads: container.querySelector('#includeMediaLibraryInBackup:checked') !== null,
            isExportingOtherWpContentFiles: container.querySelector('#includeOtherFilesInWpContent:checked') !== null,
            isExportingDatabase: container.querySelector('#includeDatabaseInBackup:checked') !== null,
            repeatBackupOnSchedule: container.querySelector('#repeatBackupOnSchedule:not(:checked)') !== null,
            scheduleRecurrence: container.querySelector('#backupScheduleRecurrence').value || null,
            scheduleTime: container.querySelector('#backupScheduleTime').value || null,
            scheduleRotation: container.querySelector('#backupScheduleRotation').value || null,
          };
        },
      });

      if (!formValues) {
        return;
      }

      WPStagingBackup.process({
        execute: () => {
          WPStagingBackup.messages.reset();
          WPStagingBackupCreate.prepareBackup(formValues);
        },
      });
    },
    prepareBackup(data) {
      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups--prepare-export',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            wpstgExportData: data,
          },
          function(response) {
            if (response.success) {
              window.dispatchEvent(new Event('startedCreatingBackup'));
              WPStagingBackup.timer.start();

              WPStagingBackupCreate.createBackup();
            } else {
              WPStagingCommon.showAjaxFatalError(response.data, '', 'Submit an error report.');
            }
          },
          'json',
          false,
          10,
          1.25,
          function(xhr, textStatus, errorThrown) {
            if (xhr.status === 423) {
              WPStagingCommon.continueErrorHandle = false;
              WPStagingBackup.shouldCleanUp = false;
              WPStagingCommon.closeSwalModal();

              setTimeout(function() {
                WPStagingBackup.shouldCleanUp = true;
              }, 1000);

              WPStagingCommon.showErrorModal(xhr.responseJSON.data);
            } else {
              WPStagingCommon.continueErrorHandle = true;
            }
          },
      );
    },
    createBackup() {
      const maxBackupSequentialReturnError = 10;
      let backupReturnedError = 0;
      WPStagingCommon.resetErrors();

      if (WPStagingBackup.isCancelled) {
        WPStagingBackup.statusStop();
        return;
      }
      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups--export',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
          },
          function(response) {
            backupReturnedError = 0;

            if (WPStagingBackup.isCancelled) {
              return;
            }

            if (typeof response === 'undefined') {
              setTimeout(function() {
                WPStagingBackupCreate.createBackup();
              }, wpstg.delayReq);
              return;
            }

            WPStagingBackup.processResponse(response);
            if (!WPStagingBackup.processInfo.interval) {
              WPStagingBackup.statusStart('create');
            }

            if (response.statusTitle === 'JOB_FAIL') {
              response.messages.push({
                'type': 'critical',
                'message': 'There was a PHP fatal error while processing the backup. You might need to check your PHP error log to find out the reason. Please contact WPSTAGING support if you need help.',
              });

              WPStagingBackup.processResponse(response);
              WPStagingBackup.cancel();
              setTimeout(WPStagingBackup.logsModal, 500);
            } else if (response.statusTitle === 'JOB_RETRY') {
              WPStagingBackup.processResponse(response);
              WPStagingBackupCreate.createBackup();
            }

            if (response.status === false) {
              WPStagingBackupCreate.createBackup();
            } else if (response.status === true) {
              $('#wpstg--progress--status').text('Backup successfully created!');

              if (WPStagingBackup.messages.shouldWarn()) {
              // noinspection JSIgnoredPromiseFromCall
                WPStagingBackup.fetchListing();
                WPStagingBackup.logsModal();
                return;
              }
              WPStagingBackup.statusStop();
              WPStagingCommon.closeSwalModal();
              WPStagingBackup.fetchListing()
                  .then(() => {
                    if (!response.backupMd5) {
                      WPStagingCommon.showError('Failed to get backup md5 from response');
                      return;
                    }

                    // Wait for fetchListing to populate the DOM with the backup data that we want to read
                    let $el = '';
                    let timesWaited = 0;
                    const intervalWaitForBackupInDom = setInterval(function() {
                      timesWaited++;
                      $el = $(`.wpstg-backup[data-md5="${response.backupMd5}"] .wpstg--backup--download`);

                      // Could not find element, let's try again...
                      if (!$el.length) {
                        if (timesWaited >= 20) {
                          // Bail: We tried too many times and couldn't find.
                          clearInterval(intervalWaitForBackupInDom);
                        }
                        return;
                      }

                      // Found it. No more need for the interval.
                      clearInterval(intervalWaitForBackupInDom);

                      const backupSize = response.hasOwnProperty('backupSize') ? ' (' + response.backupSize + ')' : '';

                      WPStagingBackup.downloadModal({
                        title: 'Backup Complete',
                      });
                      $('.wpstg--modal--download--logs--wrapper').show();
                      const $logsContainer = $('.wpstg--modal--process--logs');
                      WPStagingBackup.messages.data.all.forEach((message) => {
                        const msgClass = `wpstg--modal--process--msg--${message.type.toLowerCase()}`;
                        $logsContainer
                            .append(`<p class="${msgClass}">[${message.type}] - [${message.date}] - ${message.message}</p>`)
                        ;
                      });
                    }, 500);
                  })
              ;
            } else {
              setTimeout(function() {
                WPStagingBackupCreate.createBackup();
              }, wpstg.delayReq);
            }
          },
          'json',
          false,
          0, // Don't retry upon failure
          1.25,
          function(xhr, textStatus, errorThrown) {
            WPStagingCommon.continueErrorHandle = false;
            console.log(xhr);
            const response = {
              'messages': [],
            };

            backupReturnedError++;

            // Prevents loop in case PHP crashes constantly before being able to respond
            if (backupReturnedError <= maxBackupSequentialReturnError) {
              WPStagingBackupCreate.createBackup();
            } else {
              response.messages.push({
                'type': 'critical',
                'message': 'There was a PHP fatal error while processing the backup. You might need to check your PHP error log to find out the reason. Please contact WPSTAGING support if you need help.',
              });

              WPStagingBackup.processResponse(response);
              WPStagingBackup.cancel();
              setTimeout(WPStagingBackup.logsModal, 500);
            }
          },
      );
    },
    warnExportMediaWithoutDatabase() {
      const isExportingDatabase = document.getElementById('includeDatabaseInBackup').checked;
      const isExportingMediaLibrary = document.getElementById('includeMediaLibraryInBackup').checked;

      if (isExportingMediaLibrary && !isExportingDatabase) {
        document.getElementById('exportUploadsWithoutDatabaseWarning').style.display = 'block';
      } else {
        document.getElementById('exportUploadsWithoutDatabaseWarning').style.display = 'none';
      }
    },
    disableButtonIfNoSelection() {
      const isExportingAnyDir = $('[type="checkbox"][name="includedDirectories\[\]"]:checked').length > 0;
      const isExportingDatabase = $('input#includeDatabaseInBackup:checked').length === 1;
      const isExportingOtherFilesInWpContent = $('input#includeOtherFilesInWpContent:checked').length === 1;
      if (!isExportingAnyDir && !isExportingDatabase && !isExportingOtherFilesInWpContent) {
        $('.wpstg--swal2-confirm').prop('disabled', true);
      } else {
        $('.wpstg--swal2-confirm').prop('disabled', false);
      }
    },
  };
}(jQuery));

export default WPStagingBackupCreate;
